import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from '../../helpers/request';
import {
  ICreateTerminalBody,
  ICreateTerService,
  IRegisterTerminalService,
  IGetTerminalNoPayResponse,
  IVerifyTerminalNoPayPayload,
  IGetTerminalNoPayParams,
  IGetTerminalWaitingGrantedBankResponse,
  IGetTerminalWaitingGrantedBankParams,
} from 'interfaces';

const createTerminalService = (
  body: ICreateTerService
): Promise<{ data: { id: number } }> => {
  return bffServiceClient
    .post(`/merchant/terminalService`, body)
    .then(getResult);
};
const createTerminal = (
  body: ICreateTerminalBody
): Promise<{ data: { id: number } }> => {
  return bffServiceClient.post(`/terminals`, body).then(getResult);
};

const createTerminalServiceQR = (
  payload: IRegisterTerminalService
): Promise<{ data: { id: number } }> => {
  return bffServiceClient.post(`/terminalService/qr`, payload).then(getResult);
};

const createTerminalServiceSPOS = (
  payload: IRegisterTerminalService
): Promise<{ data: { id: number } }> => {
  return bffServiceClient
    .post(`/terminalService/spos`, payload)
    .then(getResult);
};

const createTerminalServicePOS365 = (
  payload: IRegisterTerminalService
): Promise<{ data: { id: number } }> => {
  return bffServiceClient
    .post(`/terminalService/pos365`, payload)
    .then(getResult);
};

const createTerminalServiceSapo = (
  payload: IRegisterTerminalService
): Promise<{ data: { id: number } }> => {
  return bffServiceClient
    .post(`/terminalService/sapo`, payload)
    .then(getResult);
};

const createTerminalServiceSaleDecive = (
  payload: IRegisterTerminalService
): Promise<{ data: { id: number } }> => {
  return bffServiceClient
    .post(`/terminalService/sellingDevice`, payload)
    .then(getResult);
};

const getTerminalNoPay = (
  params: IGetTerminalNoPayParams
): Promise<IGetTerminalNoPayResponse> => {
  return bffServiceClient
    .get('/terminalService/nonPaymentService', { params })
    .then(getResult);
};

const verifyTerminal = (
  id: number,
  payload: IVerifyTerminalNoPayPayload
): Promise<{ code: number; message: string }> => {
  return bffServiceClient.put(
    `/terminalService/verifyNonPaymentService/${id}`,
    payload
  );
};

const getTerminalWaitingGrantedBank = (
  params: IGetTerminalWaitingGrantedBankParams
): Promise<IGetTerminalWaitingGrantedBankResponse> => {
  return bffServiceClient
    .get('/sposContract/waitGrantMidTidBank', { params })
    .then(getResult);
};

export default {
  createTerminalService,
  createTerminal,
  createTerminalServiceQR,
  createTerminalServicePOS365,
  createTerminalServiceSPOS,
  createTerminalServiceSapo,
  createTerminalServiceSaleDecive,
  getTerminalNoPay,
  verifyTerminal,
  getTerminalWaitingGrantedBank,
};
